﻿<script setup>
    const props = defineProps({
        title: String,
        to: String,
        label: String,
        flat: Boolean,
        dense: Boolean,
        disabled: Boolean
    });

    const emit = defineEmits(['click']);

    function click() {
        emit('click');
    }
</script>

<template>
    <q-btn 
        :dense="dense"
        :round="!flat"
        :flat="flat"
        :outline="flat"
        :size="flat ? 'md' : 'sm'" 
        color="success" 
        icon="done" 
        :title="title || 'Ok'"
        :label="flat ? (label || 'Ok') : ''"
        @click="click"
        :to="to"
           :disable="disabled"/>
</template>